import { format } from "date-fns";
import { ROUTES, callAPI } from "../API/index";
import { fetchCodeList, renameKeys } from "./ServiceCommon";

// -----------------------------------------------
// E-System
// -----------------------------------------------
export const fetchESystemCodeListMenuItems = async () => {
    /**
     * 전자결재 코드 목록 반환
     */
    try {
        // 큰 카테고리 조회
        const data = await fetchCodeList(["0052"]); // API 호출
        const menuItemKeyMap = { subcategory: 'key', value: 'text', desc: 'value' }

        const resp = data.code_list
        const resp_message = data.message
        const menuItems0052 = resp.filter((item) => item.category === "0052" && item.subcategory !== "0000").map(item => renameKeys(item, menuItemKeyMap))

        // 작은 카테고리 조회
        const valueList = resp.filter((item) => item.category === "0052" && item.subcategory !== "0000").map(item => item.desc);
        const subTypeData = await fetchCodeList(valueList);
        const subTypeResp = subTypeData.code_list
        const subTypeKeyMap = { subcategory: ['key', 'value'], value: 'text' }

        // 작은 카테고리 딕셔너리 생성
        const subTypeDict = {};
        valueList.forEach(async (value) => {
            const codeData = subTypeResp.filter((item) => item.category === value && item.subcategory !== "0000").map(item => renameKeys(item, subTypeKeyMap))
            subTypeDict[value] = codeData;
        });

        return {
            draftType: menuItems0052,
            draftTypeSub: subTypeDict,
            valueList: valueList,
            resp_message: resp_message
        }
    } catch (error) {
        console.error("전자결재 코드 목록 가져오기 오류:", error);
        throw error; // 오류를 다시 던져서 호출하는 쪽에서 처리할 수 있도록 함
    }
}

export const createESystemForm = (apiData) => {
    /**
     * 전자결재 기안 생성
     */
    const formattedApiData = {
        ...apiData,
        startDate: apiData.startDate && apiData.startDate instanceof Date && !isNaN(apiData.startDate.getTime())
            ? format(apiData.startDate, 'yyyy-MM-dd HH:mm')
            : undefined,
        endDate: apiData.endDate && apiData.endDate instanceof Date && !isNaN(apiData.endDate.getTime())
            ? format(apiData.endDate, 'yyyy-MM-dd HH:mm')
            : undefined
    }
    return callAPI(ROUTES.E_SYSTEM.FORM, 'POST', formattedApiData);
}

export const updateESystemForm = (apiData) => {
    /**
     * 전자결재 기안 수정
     */
    const formattedApiData = {
        ...apiData,
        startDate: apiData.startDate && apiData.startDate instanceof Date && !isNaN(apiData.startDate.getTime())
            ? format(apiData.startDate, 'yyyy-MM-dd HH:mm')
            : undefined,
        endDate: apiData.endDate && apiData.endDate instanceof Date && !isNaN(apiData.endDate.getTime())
            ? format(apiData.endDate, 'yyyy-MM-dd HH:mm')
            : undefined
    }
    return callAPI(ROUTES.E_SYSTEM.FORM, 'PUT', formattedApiData);
}

export const fetchESystemList = async (pageType, params = {}) => {
    /**
     * 전자결재 목록 조회
     */

    if (pageType === 'leave') {

    } else if (pageType === 'vacation') {

    } else if (pageType === 'half-leave') {

    } else if (pageType === 'trip') {

    } else if (pageType === 'edu') {

    } else if (pageType === 'over') {

    } else if (pageType === 'absence') {

    }
    return callAPI(ROUTES.E_SYSTEM.LIST, 'GET', {}, { pageType, ...params });
}

export const fetchESystemDetail = async (no) => {
    /**
     * 전자결재 상세 조회
     */
    return callAPI(ROUTES.E_SYSTEM.DETAIL, 'GET', {}, { no });
}

export const recallESystemForm = async (no) => {
    /**
     * 전자결재 회수
     */
    return callAPI(ROUTES.E_SYSTEM.RECALL, 'PUT', {}, { no });
}

export const printESystemDocument = async (detailData) => {
    /**
     * 전자결재 문서 인쇄 (PD 스타일 사용)
     */
    try {
        // PDESystem의 printESystem 함수를 동적으로 import
        const { printESystem } = await import('../../styles/print-design/PDESystem');

        // 인쇄 실행
        printESystem(detailData);

        return Promise.resolve();
    } catch (error) {
        console.error('전자결재 인쇄 오류:', error);
        return Promise.reject(error instanceof Error ? error : new Error(error.message || '전자결재 인쇄 중 오류가 발생했습니다.'));
    }
}
